/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/admiral_1': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M28 19.354L31.354 16 28 12.646V4h-8.646L16 .646 12.646 4H4v8.646L.646 16 4 19.354V28h8.646L16 31.354 19.354 28H28v-8.646zM30.646 16L28 18.646v-5.293L30.646 16zM16 1.354L18.646 4h-5.293L16 1.354zM1.354 16L4 13.354v5.292L1.354 16zM16 30.646L13.354 28h5.292L16 30.646zM26 26H6V6h20v20z"/><path pid="1" d="M10.95 21.189v.928l5.14-5.146 5.06 5.021v-.885l-5.06-5.058z"/><path pid="2" d="M16.09 15.232l5.06 5.061v-.922l-5.06-5.06-5.14 5.14v.92z"/><path pid="3" d="M16.066 13.545l3.612 3.551 5.092-3.334h-6.956l-1.822-5.879-1.658 5.879H7.23l5.176 3.381z"/>'
  }
})
